import { useUiLanguage } from "@/i18n/useUiLanguage";
import { tr } from "@/i18n/copy";
import TpsBrand from "@/components/TpsBrand";
export default function TpsAccessSplash() {
  useUiLanguage();
  return <div className="tps-access-splash" role="status" aria-label={tr("Accesso a Tattoo Pro Studio in corso")}>
    <div className="tps-access-mark"><TpsBrand />
      <div className="tps-access-frequency" aria-hidden="true">{[0,1,2,3,4,5,6,7,8].map(index=><span key={index} style={{animationDelay:`${index * 90}ms`}} />)}</div>
    </div>
    <span className="tps-access-caption">{tr("Accesso in corso…")}</span>
  </div>;
}
